import { createAsyncThunk } from "@reduxjs/toolkit";

import { CasProfileApi } from "@jti/rest-api";

export const fetchContactEmail = createAsyncThunk("order/fetchContactEmail", async () => {
  const casProfileApi = CasProfileApi.init();
  return casProfileApi.getProfile();
});
